import 'whatwg-fetch';
import Vue from 'vue';
import App from '@/App.vue';
import router from './registerRouter';
import store from './store/index';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import HighchartsVue from 'highcharts-vue';
import i18n from './i18n';
import { Buffer } from 'buffer';
// Import icomoon CSS for custom icons
import '../ux/glyphfont/style.css';

import VeeValidate from 'vee-validate';
import validationMessagesEn from 'vee-validate/dist/locale/en';
import validationMessagesFr from 'vee-validate/dist/locale/fr';
import boost from 'highcharts/modules/boost';
import HighchartsMore from 'highcharts/highcharts-more';
import Highcharts from 'highcharts';
import stockInit from 'highcharts/modules/stock';
import { filters } from '@/filters';
import axios from 'axios';

axios.defaults.adapter = 'xhr';

// Polyfill Buffer for browser (needed for csv-parse)
if (typeof window !== 'undefined') {
  (window as any).Buffer = Buffer;
  (globalThis as any).Buffer = Buffer;
}

// Polyfill globalThis.Request for browser (must be after imports)
if (
  typeof globalThis.Request === 'undefined' &&
  typeof window !== 'undefined' &&
  typeof window.Request !== 'undefined'
) {
  globalThis.Request = window.Request;
}
if (
  typeof window !== 'undefined' &&
  typeof window.Request === 'undefined' &&
  typeof globalThis.Request !== 'undefined'
) {
  window.Request = globalThis.Request;
}

if (window.navigator && navigator.serviceWorker) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (const registration of registrations) {
      registration.unregister();
    }
  });
}

Vue.use(filters);
Vue.use(Vuetify);
const vuetify = new Vuetify();

// read: https://baianat.github.io/vee-validate/guide/localization.html
Vue.use(VeeValidate, {
  i18nRootKey: 'validations',
  i18n,
  dictionary: {
    en: validationMessagesEn,
    fr: validationMessagesFr
  }
});

stockInit(Highcharts);
boost(Highcharts);
HighchartsMore(Highcharts);
Vue.use(HighchartsVue);

Vue.config.productionTip = false;

// ensure Vite runtime env is accessible to our helpers via globalThis
(globalThis as any).__VITE_ENV__ = process.env;

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App)
}).$mount('#app');
